export default __webpack_public_path__ + "61dd7399ea7efcc1d962b9ccc0956f37.png";